module.exports = __webpack_public_path__ + "main/assets/fonts/scoville/scoville.eot";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/scoville/scoville.eot
// module id = 1280
// module chunks = 0